module.exports = __webpack_public_path__ + "img/crime_scene_splash.ba7c6252.jpg";